export var DEFAULT_SETTINGS = {
  hideCredits: true,
  fontSize: 14,
  fontFamily: 'lato',
  chartCursor: {
    // oneBalloonOnly: true,
    cursorColor: '#3D85D1'
  },
  path: process.env.NODE_ENV === 'development' ? '/amcharts' : '/apps/analytics/amcharts'
};
export var VALUE_AXIS_SETTINGS = {
  precision: 0
};
export var LEGEND_SETTINGS = {
  autoMargins: false,
  borderAlpha: 0,
  markerBorderThickness: 6,
  markerSize: 10,
  markerLabelGap: 10,
  spacing: 36,
  verticalGap: 12,
  valueAlign: 'left',
  valueWidth: 30,
  valueText: '[[value]]',
  labelText: '[[title]]'
};
export var RESPONSIVE_SETTINGS = {
  rules: [{
    maxHeight: 200,
    overrides: {
      legend: {
        enabled: false
      }
    }
  }, {
    maxWidth: 400,
    overrides: {
      categoryAxis: {
        labelsEnabled: false
      },
      valueAxes: {
        labelsEnabled: false
      }
    }
  }, {
    maxWidth: 600,
    overrides: {
      categoryAxis: {
        fontSize: 10
      }
    }
  }]
};